import { linkBridge } from '@webview-bridge/web'

import type { AppBridge } from '@podo/native'

// 외부 LINE 앱/브라우저에서 사용자가 인증하는 동안 기본 bridge timeout(2초)을 넘는다.
// 다른 짧은 native action의 실패 감지를 늦추지 않도록 LINE 로그인 전용 bridge만 분리한다.
export const NATIVE_LINE_LOGIN_TIMEOUT_MS = 10 * 60 * 1_000

export const nativeLineLoginBridge = linkBridge<AppBridge>({
  timeout: NATIVE_LINE_LOGIN_TIMEOUT_MS,
  throwOnError: ['startLineLogin'],
})
